/**
 * Constantes para chaves do localStorage.
 * IMPORTANTE: Os valores destas chaves NÃO DEVEM SER ALTERADOS para preservar a
 * compatibilidade com os dados de usuários e arenas já existentes no ambiente.
 */
export const STORAGE_KEYS = {
  // Perfis de usuário
  USER_PROFILE_ACTIVE: "arena_esportes_user_profile_v2",
  USER_PROFILE_LEGACY_1: "app_user_profile_v2",
  USER_PROFILE_PREFIX: "arena_esportes_user_profile_",
  APP_USER_PROFILE_PREFIX: "app_user_profile_",

  // Configurações do Sistema e Comissões
  SYSTEM_SETTINGS: "app_system_settings_v2",
  COMMISSION_RATE: "app_platform_commission_rate",
  FIXED_FEE: "app_platform_fixed_fee",
  FEE_MODE: "app_platform_fee_mode",

  // Day Use & Torneios
  DAY_USE_TICKETS: "play_arena_day_use_tickets",
  TOURNAMENT_BOOKING_REQUESTS: "play_arena_tournament_booking_requests",
  GROUP_DAY_USE_RESERVATIONS: "play_arena_group_day_use_reservations",
  DAY_USE_CONFIG: "hub_esportivo_dayuse_configs_v1",

  // Faturamento Mensal
  MONTHLY_INVOICES: "app_monthly_invoices_v2",

  // Financeiro de Arenas e Torneios
  FINANCES_PREFIX: "arena_esportes_finances_",
  PLAYARENA_FINANCE_PREFIX: "playarena_finance_",
  RECALCULATED_FINANCIALS_CACHE: "hub_esportivo_recalculated_financials_v1",

  // Rachão de Vôlei / Jogos
  RACHAO_DUPLAS: "vôlei_rachao_duplas",
  RACHAO_GAME_STATE: "vôlei_rachao_gameState",
  RACHAO_HISTORICO: "vôlei_rachao_historico",
  RACHAO_HOST_ID: "vôlei_rachao_local_host_id",
  RACHAO_SESSOES: "vôlei_rachao_sessoes",
  RACHAO_TORNEIOS: "vôlei_rachao_torneios",
  RACHAO_PLAYERS_DRAW: "vôlei_rachao_jogadores_sorteio",
  RACHAO_COURTS: "app_courts_v2",

  // Vouchers
  VOUCHERS: "hub_esportivo_vouchers_v1",

  // Regras Comerciais, Cortesias & Auditoria Administrativa
  COMMERCIAL_COURTESIES: "hub_esportivo_commercial_courtesies_v1",
  COMMERCIAL_AUDIT_LOGS: "hub_esportivo_commercial_audit_logs_v1",

  // Verificações, Reportes e Avaliações de Arena
  ARENA_VERIFICATIONS: "hub_arena_verifications",
  ARENA_REPORTS: "hub_arena_reports",
  ARENA_REVIEWS: "hub_arena_reviews",

  // Bloqueios e Manutenção de Quadras (Canônico G4-B)
  COURT_BLOCKS: "hub_court_blocks_v1",

  // Contexto da Aplicação (Aparência / Zoom)
  THEME_MODE: "theme_mode",
  APP_ZOOM_LEVEL: "app_zoom_level",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
